import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PLATFORMS, TRAY_LIKE_PLATFORMS } from '../../../Editor/_helpers/constants';

import { makeStyles } from '@material-ui/core/styles';
import Shipping from '../Shipping/Shipping';

import { getSelectedArea } from '../../../Editor/_reducers/theme.reducer';
import _, { isEmpty } from 'lodash';
import { productsActions } from '../../../Editor/_actions/products.actions';
import CartItem from './CartItem';
import { CircularProgress } from '@material-ui/core';
import BuyButtonArea from './BuyButtonArea';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#e5e5e5',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    width: '100%',
    position: 'relative',
  },
  list: {
    padding: '0px 10px',
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 15px',
    background: '#fff'
  },
  summaryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  separator: {
    borderBottom: '1px solid #ccc',
    margin: '10px 0px'
  },
  subtotalText: {
    fontSize: 14,
    color: '#666'
  },
  subtotalValue: {
    fontSize: 14,
    color: '#333',
    fontWeight: '500'
  },
  totalText: {
    fontSize: 16,
    color: '#333',
    fontWeight: 'bold'
  },
  totalValue: {
    fontSize: 18,
    color: '#000',
    fontWeight: 'bold'
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: 10,
    height: '100%',
    width: '100%',
  },
}));

const CartScreen = () => {
  const dispatch = useDispatch();
  const selectedArea = useSelector(state => getSelectedArea(state));
  const data = selectedArea.sections.find(s => s.key === 'cartScreen');
  const sections = _.get(selectedArea, 'sections', []);
  const settings = sections.find(s => s.key === 'cartScreenSettings');
  const options = _.get(settings, 'options', {});

  const platform = useSelector(state => state.StoreReducer.platform);

  const colors = useSelector(state => state.ThemeReducer.settings.find(s => s.key === 'colors'));
  const classes = useStyles(colors);

  const [ products, setProducts ] = useState([]);

  useEffect(() => {
    const defaultSorting = _.get(data, 'options.defaultSorting', null);
    let filters = {};

    switch(platform){
      case PLATFORMS.BAGY:
      case PLATFORMS.TRAY:
        filters = {
          limit: 3,
          sort: _.isEmpty(defaultSorting) ? 'release_desc' : defaultSorting
        };
        break;
      case PLATFORMS.IRROBA:
        filters = {
          per_page: 3,
          sort_by: _.isEmpty(defaultSorting) ? 'release-desc' : defaultSorting
        };
        break;
      default:
        filters = {
          per_page: 3,
          sort_by: _.isEmpty(defaultSorting) ? 'created-descending' : defaultSorting
        };
        break;
    }

    dispatch(productsActions.getProducts(filters))
      .then(response => {
        setProducts([response.products[0], response.products[2]]);
      })
      .catch(() => {
        setProducts([]);
      })
  }, []);

  if(isEmpty(products)){
    return (
      <div className={classes.loadingWrapper}>
        <CircularProgress color="primary"/> 
      </div>
    )
  }

  const getCartPrice = () => {
    let totalValue = 0;

    for(const product of products){
      totalValue = totalValue + product?.price
    }


    if(totalValue.toString().search(/[.]/) == -1){
      return `R$ ${totalValue},00`
    }else{
      const format = totalValue.toString().split('.');

      const before = format[1].slice(0,2).length < 2 
          ? `${format[1].slice(0,2)}0`
          : format[1].slice(0,2)

      return `R$ ${format[0]},${before}`
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.list}>
        {products.map((item, index) => (
          <CartItem colors={colors} product={item} />
        ))}
        {TRAY_LIKE_PLATFORMS.includes(platform) && options.showShipping
          ? <Shipping colors={colors} isCartScreen={true} enableSummary={true} products={products} />
          : <div className={classes.summary}>
            <div className={classes.summaryWrapper}>
              <span className={classes.subtotalText}>
                Subtotal
              </span>
              <span className={classes.subtotalValue}>
                {!isEmpty(products) && getCartPrice()}
              </span>
            </div>

            <div className={classes.separator}></div>

            <div className={classes.summaryWrapper}>
              <span className={classes.totalText}>
                Total
              </span>
              <span className={classes.totalValue}>
                {!isEmpty(products) && getCartPrice()}
              </span>
            </div>
          </div>
        }
      </div>
      <BuyButtonArea colors={colors} />
    </div>

  )
}

export default CartScreen;